import { render, staticRenderFns } from "./ProductResults.vue?vue&type=template&id=8e3a8914&"
import script from "./ProductResults.vue?vue&type=script&lang=js&"
export * from "./ProductResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports